export const REMOTE_CONFIG_KEYS = {
  TIME_TRACKER: 'time_tracker',
  LOCATION_ALERTS: 'location_alerts_view',
  EMERGENCIES: 'emergencies_module',
  WORKER_SCORE: 'worker_score_module',
  /** Supervisor closure of work orders (ADR 0002); enforced by the backend too. */
  SUPERVISOR_CLOSE: 'supervisor_close',
  /** Cost centers configuration module; org map, off by default (GUA-369). */
  COST_CENTERS: 'cost_centers_module',
} as const;

export type RemoteConfigKey = (typeof REMOTE_CONFIG_KEYS)[keyof typeof REMOTE_CONFIG_KEYS];

export type RemoteConfigPolicy = {
  shape: 'orgsAllowed' | 'orgMap';
  empty: 'allow' | 'deny';
};

export const REMOTE_CONFIG_POLICIES: Record<RemoteConfigKey, RemoteConfigPolicy> = {
  [REMOTE_CONFIG_KEYS.TIME_TRACKER]: { shape: 'orgsAllowed', empty: 'deny' },
  [REMOTE_CONFIG_KEYS.LOCATION_ALERTS]: { shape: 'orgMap', empty: 'allow' },
  [REMOTE_CONFIG_KEYS.EMERGENCIES]: { shape: 'orgMap', empty: 'deny' },
  [REMOTE_CONFIG_KEYS.WORKER_SCORE]: { shape: 'orgMap', empty: 'deny' },
  [REMOTE_CONFIG_KEYS.SUPERVISOR_CLOSE]: { shape: 'orgMap', empty: 'deny' },
  [REMOTE_CONFIG_KEYS.COST_CENTERS]: { shape: 'orgMap', empty: 'deny' },
};

export const withRemoteConfigKey = <T extends object>(
  remoteConfigKey: RemoteConfigKey,
  routes: T[],
): Array<T & { remoteConfigKey: RemoteConfigKey }> =>
  routes.map(route => ({ ...route, remoteConfigKey }));
